'use strict'

import Highstock from 'highcharts/highstock';
import {isNumber} from "highcharts";
import HC_exporting from 'highcharts/modules/exporting';
import HC_exportData from 'highcharts/modules/export-data';
HC_exporting(Highstock);
HC_exportData(Highstock);

export default {

  /**
   * Initialise
   */
  init() {

    $('.table-from-sheets').each(function(){
      const $self = $(this);
      $.getJSON(
        'https://02mvmo72z4.execute-api.eu-west-2.amazonaws.com/prod/sheet/' + $self.data('id'),
        { sheet: $self.data('tab'), range: $self.data('range'), headers: $self.data('headers') }
      )
        .done(function(data){
          for (let i = 0; i < data.cols.length; i++) {
            if ( data.cols[i].label ) {
              $self.find(`th[data-idx='${i}']`).html(data.cols[i].label);
            } else {
              $self.find(`th[data-idx='${i}']`).html('');
            }
          }
          for (let i = 0; i < data.rows.length; i++) {
            for (let j = 0; j < data.rows[i].length; j++) {
              let val = data.rows[i][j];

              // Fix unicode issues
              val = val.replace(/u([\da-f]{4})/g, (_, v) => String.fromCharCode(parseInt(v, 16)));

              // Parse URLs into <a href>
              val = val.replace(/(https?:\/\/.+)/g, (_, v) => {
                let title = $self.data('url-label') || v;
                return `<a class="icon-file" href="${v}" target="_blank">${title}</a>`
              });

              $self.find(`[data-idx='${i}.${j}']`).html(val);
            }
          }
        })
        .fail(function(){
          console.error('failed connection');
        });
    });

    $('.field-from-sheets').each(function(){
      const $self = $(this);
      $.getJSON(
        'https://02mvmo72z4.execute-api.eu-west-2.amazonaws.com/prod/sheet/' + $self.data('id'),
        { sheet: $self.data('tab'), range: $self.data('range') }
      )
        .done(function(data){
          $self.text(data.rows[0][0]);
        })
        .fail(function(){
          console.error('failed connection');
        });
    });

    $('.files-from-sheets').each(function(){
      const $self = $(this);
      const filenameTemplate = $self.data('template');
      $.getJSON(
        'https://02mvmo72z4.execute-api.eu-west-2.amazonaws.com/prod/sheet/' + $(this).data('id'),
        { sheet: $(this).data('tab'), range: $(this).data('range') }
      )
        .done(function(data){
          for (let i = 0; i < data.rows.length; i++) {
            let $li = $self.find(`[data-idx='${i}']`);
            let $a = $li.find('a');
            let href = '', filename = filenameTemplate;

            // We don't know what order the columns will be in, so scan them for a url and build up the filename
            for (let j = 0; j < data.rows[i].length; j++) {
              filename = filename.replace(new RegExp(`\\{${j+1}\\}`), data.rows[i][j])
              if ( data.rows[i][j].match(/^http/) ) {
                href = data.rows[i][j];
              }
            }

            // If there was no URL at all, remove this item and skip
            if ( href === '' ) {
              $li.remove();
              continue;
            }

            // Populate the DOM
            $a
              .html(filename)
              .attr('href', href);
          }
        })
        .fail(function(){
          console.error('failed connection');
        });
    });

    const primaryColor    = '#2C626C'; //primary
    const secondaryColor  = '#3F99B1'; //secondary
    const tertiaryColor   = '#2C426C'; //blue dark
    const fontColor       = '#000000'; //black
    const fontSize        = '16px';
    const fontFamily      = 'Rubik, sans-serif';

    // Apply the theme
    Highstock.setOptions({
      colors: [primaryColor, secondaryColor],
      chart: {
        backgroundColor: '#FFFFFF',
        plotBackgroundColor: '#FFFFFF',
        height: 600,
      },
      xAxis: {
        lineColor: fontColor,
        tickColor: fontColor,
        labels: {
          style: {
            color: fontColor,
          },
        },
        title: {
          style: {
            color: fontColor,
            fontSize: fontSize,
            fontFamily: fontFamily,
          },
        },
      },
      yAxis: {
        backgroundColor: '#F9F7F1',
        lineColor: fontColor,
        tickColor:fontColor,
        labels: {
          style: {
            color: fontColor,
          },
        },
        title: {
          style: {
            color: fontColor,
            fontSize: fontSize,
            fontFamily: fontFamily,
            fontWeight: 'bold',
          },
        },
      },
      rangeSelector: {
        inputStyle: {
          color: fontColor,
        },
      },
      navigator: {
        handles: {
          backgroundColor: '#DDDAD2',
          borderColor: '#737B7D',
        },
        outlineColor: '#737B7D',
        maskFill: 'rgba(255,255,255, 0.40)',
        series: {
          color: '#FFFFFF',
          lineColor: '#000000',
          fillColor: '#F4F5F4',
          dataLabels: {
            style: {
              color: '#FFFFFF',
            },
          },
        },
      },
      scrollbar: {
        barBackgroundColor: '#E2E5E6',
        buttonArrowColor: '#000000',
        buttonBackgroundColor: '#DDDAD2',
        rifleColor: '#FFFFFF',
        trackBackgroundColor: '#DDDAD2',
      },
    });

    $('.chart-from-sheets.chart-type-line_series').each(function(){
      const colors = $(this).data('colors');
      const chart = Highstock.stockChart(this, {
        colors,
        title: {
          text: '',
          align:'left',
          style: {
            color: fontColor,
          },
        },
        xAxis: {
          type: 'datetime',
        },
        yAxis: [
          {
            title: {
              text: 'Price',
            },
            opposite: false,
          },
        ],
        series: {
            lineWidth: '5',
        },
        exporting: {
            sourceWidth: 1050,
            sourceHeight: 600,
            chartOptions: {
                navigator: {
                    enabled: false
                },
                scrollbar: {
                    enabled: false
                },
                credits: {
                    enabled: false
                },
                rangeSelector: {
                    enabled: false
                },
                plotOptions: {
                    series: {
                        lineWidth: '3',
                    },
                },
                yAxis: {
                    labels: {
                        style: {
                            fontSize: '16px',
                        },
                    },
                },
                xAxis: {
                    labels: {
                        style: {
                            fontSize: '16px',
                        },
                    },
                },
            },
        },
      });
      chart.showLoading();

      const id = $(this).data('id'), sheet = $(this).data('tab'), pages = $(this).data('pages'), range = $(this).data('range');
      const promises = [];
      const url = `https://02mvmo72z4.execute-api.eu-west-2.amazonaws.com/prod/sheet/${id}`;

      if ( typeof pages !== 'undefined' && isNumber(pages) ) {

        for (let i = 0; i <= pages; i++) {
          let data = {
            sheet: sheet,
          };

          if ( range.match(/[A-Z]{1,2}[0-9]*:[A-Z]{1,2}[0-9]*/g) ) {
            // Range used, eg A1:D
            data['range'] = range;
          } else {
            data['tq'] = `${range} limit 1000 offset ${i*1000}`;
          }
          promises.push($.getJSON(url, data))
        }

      } else {
        promises.push($.getJSON(url, { sheet: sheet, range: range }));
      }

      Promise.all(promises).then((dataArr) => {
        let data = {}
        data.cols = dataArr[0].cols;
        data.rows = [];
        for ( let i = 0; i < dataArr.length; i++ ) {
          data.rows = data.rows.concat(dataArr[i].rows)
        }

        let i=0, len = data.rows.length, values=[], benchmark=[];
        while (i < len) {
          values.push([parseInt(data.rows[i][0]),parseInt(data.rows[i][1])]);
          if ( data.cols[2] ) {
            benchmark.push([parseInt(data.rows[i][0]),parseInt(data.rows[i][2])]);
          }
          i++;
        }
        chart.addSeries({
          'yAxis': 0,
          'type': 'line',
          'name': data.cols[1].label,
          'data': values,
        });
        if ( data.cols[2] ) {
          chart.addSeries({
            'yAxis': 0,
            'type': 'line',
            'name': data.cols[2].label,
            'data': benchmark,
          });
        }
        chart.hideLoading();
      });

    });

    $('.chart-from-sheets.chart-type-donut, .chart-from-sheets.chart-type-donut_notable').each(function(){
      const $this = $(this); // Performance improvement
      const centerLabel = ($this.data('center-label') == '1');
      const colors = $this.data('colors');
      const chart = Highstock.chart(this, {
        chart: {
          type: 'pie',
        },
        title: {
          text: '',
          align:'center',
          verticalAlign: 'middle',
          style: {
            color: fontColor,
          },
        },
        plotOptions: {
          pie: {
            shadow: false,
            center: ['50%', '50%'],
            dataLabels: {
              enabled: false,
            }
          },
        },
        credits: {
          enabled: false,
        },
      });
      chart.showLoading();

      $.getJSON(
        'https://02mvmo72z4.execute-api.eu-west-2.amazonaws.com/prod/sheet/' + $this.data('id'),
        { sheet: $this.data('tab'), range: $this.data('range') }
      )
        .done(function(data){
          let i=0, len = data.rows.length, values=[];
          while (i < len) {
            if ( centerLabel && i === 0 ) {
              chart.setTitle({ text: parseInt(data.rows[i][1]) + '%' });
            }
            values.push({
              name: data.rows[i][0],
              y: parseInt(data.rows[i][1]),
              color: colors[i],
            });
            i++;
          }
          chart.addSeries({
            // size: '80%',
            innerSize: '80%',
            'name': data.cols[1].label,
            'data': values,
          });

          // Table hover handler
          if ( $this.data('type') === 'donut' ) {
            $(`table.sheet-hash-${$this.data('hash')} tr`).not(':first').on('mouseenter mouseleave', (e) => {
              const idx = `${$(e.target).data('idx')}`.match(/^([0-9]+)\./)[1];
              switch ( e.type ) {
                case 'mouseenter':
                  chart.series[0].data[idx].setState('hover');
                  chart.tooltip.refresh(chart.series[0].data[idx]);
                  break;
                case 'mouseleave':
                  chart.series[0].data[idx].setState();
                  chart.tooltip.hide();
                  break;
              }

            });
          }

          chart.hideLoading();
        })
        .fail(function(){
          console.error('failed connection');
        });


    });

  },



}
